module.exports = __webpack_public_path__ + "img/icon1.aec69a08.png";